import React, { useEffect, useState } from "react";
import "./style.css";
import { useSelector, useDispatch } from "react-redux";
import { getAvailableProvidersAsync, updateUserAiSetting } from "../../../utilities/server";
import { toast } from "react-toastify";
import {
  fetchProviders,
  fetchNonEmbeddingModels,
  findModelByProviderId,
  getApiModelNameFromCache,
} from "../../../utilities/providerService";
import { setAiProvider, setAiModel, setAiApiKey } from "../../actions/user";

export const AiSettings = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const [providers, setProviders] = useState([]);
  const [allModels, setAllModels] = useState([]);
  const [availableModels, setAvailableModels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modelWithApiKey, setModelWithApiKey] = useState([]);

  const { aiProvider, aiModel, aiApiKey } = user;

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const loadedProviders = await fetchProviders();
        setProviders(loadedProviders);
        if (loadedProviders.length > 0) {
          const loadedModels = await fetchNonEmbeddingModels();
          setAllModels(loadedModels);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to load data");
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    if (aiProvider && allModels.length > 0) {
      const selectedProvider = providers.find(
        (provider) => provider.providerName === aiProvider
      );
      if (selectedProvider) {
        const models = findModelByProviderId(allModels, selectedProvider.id);
        setAvailableModels(models);
      }
    } else {
      setAvailableModels([]);
    }
  }, [aiProvider, allModels, providers]);

  useEffect(() => {
    const userId: string = user.id;
    getAvailableProvidersAsync(userId).then((data) => {
      setModelWithApiKey(data || []);
    });
  }, [aiProvider, providers, user.id, dispatch]);

  const updateChanges = async () => {
    const res = await updateUserAiSetting(
      user.accessToken,
      aiProvider,
      aiModel,
      aiApiKey
    );
    if (res) {
      toast.success("Keys Updated!", {
        toastId: "keys-update-success",
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } else {
      toast.error("Error occured", {
        toastId: "keys-update-error",
        position: toast.POSITION.BOTTOM_LEFT,
      });
      console.log("error");
    }
  };

  if (isLoading) {
    return <div className="Ai-Settings">Loading providers...</div>;
  }

  if (error) {
    return <div className="Ai-Settings">Error loading providers: {error}</div>;
  }

  return (
    <div className="Ai-Settings">
      <div>
        <select
          name="provider"
          id="provider"
          onChange={(e) => {
            dispatch(setAiProvider(e.target.value));
            console.log(providers);
          }}
          value={aiProvider || ""}
        >
          <option value="">Please Select AI Provider</option>
          {providers
            .filter((provider) =>
              modelWithApiKey.some((model) => model.id === provider.id)
            )
            .map((provider) => (
              <option key={provider.id} value={provider.providerName}>
                {provider.providerName}
              </option>
            ))}
        </select>
        {!aiProvider && (
          <span className="error">{"You have to select AI provider."}</span>
        )}
      </div>
      <div>
        <select
          name="model"
          id="model"
          onChange={(e) => dispatch(setAiModel(e.target.value))}
          value={aiModel || ""}
        >
          <option value="">Please Select AI Model</option>
          {availableModels.map((model) => (
            <option key={model.id} value={model.modelName}>
              {model.modelName}
            </option>
          ))}
        </select>
        {!aiModel && (
          <span className="error">{"You have to select AI model."}</span>
        )}
        {aiModel && (
          <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
            API Model:{" "}
            {getApiModelNameFromCache(allModels, aiModel) || "Not available"}
          </div>
        )}
      </div>

      <div>
        <button type="button" className="updateBtn" onClick={updateChanges}>
          Update Changes
        </button>
      </div>
    </div>
  );
};

export default AiSettings;
